const CONSENT_CREATED = 'banking:consent-created'
const CONSENT_UPDATED = 'banking:consent-updated'

export {CONSENT_CREATED, CONSENT_UPDATED}
